/*
 * SS-CUSTOM: pdp-quantity
 * Gives the tile PDP the two behaviours its own collection card already has:
 * coverage counts up as packs are added, and the running total rides on Add to
 * cart.
 *
 * A customer meets both figures on the grid, clicks the colour they want, and
 * lands on a page where they go dead: coverage stuck on one pack and a bare
 * "Add to cart". The card was the better page to buy from, which is backwards.
 * The pack helper made it worse again, writing 15 packs into the quantity box
 * while the line above still read 2.56m2.
 *
 * Everything is read from data attributes rendered by ss-price-per-sqm, so this
 * never parses money out of the DOM. Dawn replaces the whole product-info block
 * on a variant change, taking the coverage line and the button with it, so the
 * paint is driven from an observer rather than bound once to elements that stop
 * existing.
 */
(function () {
  'use strict';

  var FORMAT = new Intl.NumberFormat('en-AU', {
    style: 'currency',
    currency: 'AUD',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });

  function packMeta() {
    return document.querySelector('[data-ss-pdp-pack]');
  }

  function quantity() {
    // the main buy box, never the sticky bar or a quick-add card
    var input = document.querySelector(
      '.product-form__quantity input[name="quantity"], product-info input[name="quantity"]'
    );
    return Math.max(1, parseInt(input && input.value, 10) || 1);
  }

  // The total sits inside the button's own label span, the same idiom the
  // collection card uses. Inside the label it inherits the button's type and
  // can never become a second line that changes the button's height.
  function totalSpan(button) {
    if (!button || button.disabled) return null;

    var existing = button.querySelector('[data-ss-pdp-total]');
    if (existing) return existing;

    var label = button.querySelector('span');
    if (!label) return null;

    var span = document.createElement('span');
    span.setAttribute('data-ss-pdp-total', '');
    label.appendChild(span);
    return span;
  }

  // Every write is guarded, because the observer below watches the same subtree
  // it is writing into. Without the guard a repaint would trigger a repaint.
  function set(node, text) {
    if (node && node.textContent !== text) node.textContent = text;
  }

  function paint() {
    var meta = packMeta();
    if (!meta) return;

    var qty = quantity();

    var area = parseFloat(meta.dataset.packArea);
    if (area > 0) {
      set(meta.querySelector('[data-ss-pdp-area]'), (qty * area).toFixed(2) + 'm²');
    }

    var cents = parseInt(meta.dataset.packPrice, 10);
    if (!(cents > 0)) return;
    // Non-breaking space, not a plain one. The button's label is display:flex,
    // so the label text and this total are separate flex items and an ordinary
    // leading space sits at the start of its own line box and is dropped: the
    // button rendered "Add to cart· $1,680" with the two run together.
    var total = ' · ' + FORMAT.format((qty * cents) / 100);

    // the main buy box only: the phone bar shows its own total beside its stepper
    set(totalSpan(document.querySelector('product-info button[name="add"]')), total);
  }

  // Delegated so the quantity input can be replaced without re-binding. Covers
  // typing, the +/- steppers, and the pack helper writing a count in.
  document.addEventListener('input', function (event) {
    if (event.target.closest('.product-form__quantity, product-info')) paint();
  });
  document.addEventListener('change', function (event) {
    if (event.target.closest('.product-form__quantity, product-info')) paint();
  });

  function watch() {
    var root = document.querySelector('product-info');
    if (!root) return;
    // A variant change re-renders the block with fresh Liquid values and drops
    // the injected total, so repaint once the swap has settled.
    new MutationObserver(function () {
      window.requestAnimationFrame(paint);
    }).observe(root, { childList: true, subtree: true });
  }

  function init() {
    paint();
    watch();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
